export default function StatCard({ label, value, icon: Icon, tone = "slate", sub, testId }) {
  const tones = {
    slate: "text-slate-500",
    green: "text-[#16A34A]",
    amber: "text-[#D97706]",
    red: "text-[#DC2626]",
    blue: "text-[#2563EB]",
  };
  return (
    <div data-testid={testId} className="rounded-lg border bg-card p-4 transition-all duration-150 hover:-translate-y-[1px] hover:shadow-sm">
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
        {Icon && <Icon className={`h-4 w-4 ${tones[tone]}`} />}
      </div>
      <p className="mt-2 font-heading text-3xl font-semibold tabular-nums">{value}</p>
      {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
    </div>
  );
}
